<template>
  <div>
    <form
      ref="form"
      @submit.prevent="checkForm"
    >
      <!-- 모달 컨텐츠 -->
      <div class="modal__contents">
        <div class="modal__middlebox">
          <div class="modal__row">
            <h2 class="subtitle subtitle--modal">
              필수 스킬을 선택 해주세요
            </h2>
          </div>
          <div class="modal__row">
            <div class="formfield">
              <ul class="formfield__row">
                <li
                  v-for="(item, index) in skills"
                  :key="index"
                  class="formfield__inputitem"
                >
                  <div class="checkbox checkbox--border">
                    <input
                      :id="item.code"
                      v-model="req.skill.skills"
                      class="checkbox__input"
                      type="checkbox"
                      name="skill"
                      :value="item.code"
                      :disabled="req.skill.tbd"
                    >
                    <label
                      class="checkbox__label checkbox__label--right"
                      :for="item.code"
                    >
                      {{ item.name }}
                    </label>
                  </div>
                </li>
                <li class="formfield__inputitem">
                  <!--
                    [todo]
                    - label 위에 올라간 버튼을 만들어
                    - label에 + 모양 제거하고 버튼에 추가 해야 함
                    - Enter 키로도 입력 가능하나, 마우스 클릭으로도 입력 되어야 함
                  -->
                  <label
                    class="formfield__label formfield__label--add"
                    :class="{ 'formfield__label--etc' : newSkill }"
                  >
                    <input
                      v-model.trim="newSkill"
                      class="formfield__input formfield__input--add"
                      placeholder="직접입력"
                      type="text"
                      :disabled="req.skill.tbd"
                      @keypress.enter.prevent="addSkill"
                    >
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="modal__bottombox">
          <div class="checkbox">
            <input
              id="check"
              v-model="req.skill.tbd"
              class="checkbox__input"
              type="checkbox"
              name="check"
            >
            <label
              class="checkbox__label"
              for="check"
            >
              아직 결정되지 않았습니다.
            </label>
          </div>
        </div>
      </div>
      <!-- 모달 푸터(bottom) -->
      <div class="modal__footer">
        <ul class="modal__buttons">
          <li class="modal__buttonitem">
            <button
              type="button"
              class="button button--large button--secondary"
              @click="save"
            >
              임시저장
            </button>
          </li>
          <li class="modal__buttonitem">
            <button
              type="submit"
              class="button button--large"
              :disabled="!req.skill.tbd && !req.skill.skills.length"
            >
              다음
            </button>
          </li>
        </ul>
      </div>
      <!-- 모달 이전 -->
      <div class="modal__prevbutton">
        <button
          class="button button--function"
          @click="prev"
        >
          이전
        </button>
      </div>
    </form>
  </div>
</template>
<script>
export default{
  name:'Skill',
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  emits: ['next-step', 'prev-step', 'save-click', 'goto-step'],
  data(){
    return {
      req: this.request,
      newSkill: '',
      skills: [
        { name: 'HTML/CSS', code: 'HTMLCSS' },
        { name: 'Vue.js', code: 'VUEJS' },
        { name: 'jQuery', code: 'JQUERY' },
        { name: 'JavaScript', code: 'JAVASCRIPT' },
        { name: 'Responsive', code: 'RESPONSIVE' },
        { name: 'Bootstrap', code: 'BOOTSTRAP' },
        { name: 'Ajax', code: 'AJAX' },
        { name: 'Sass', code: 'SASS' }
      ]
    }
  },
  methods:{
    checkForm() {
      this.$emit('next-step')
    },
    addSkill() {
      console.log('add event')
      if (this.newSkill) {
        const name = this.newSkill
        const code = this.newSkill.toUpperCase()
        let isUnique = true

        this.skills.forEach(item => {
          if (item.code === code) {
            isUnique = false
          }
        })

        if(isUnique) {
          this.skills.push({
            name: name,
            code: code
          })
          this.req.skill.skills.push(code)
          this.resetNewSkill()
        }
      }
    },
    resetNewSkill() {
      this.newSkill = ''
    },
    save() {
      this.$emit('save-click')
    },
    prev() {
      if (this.req.supportDevice.devices.length < 2) {
        this.$emit('goto-step', 'supportDevice')
      } else {
        this.$emit('prev-step')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.modal{
  $self:&;
  &__buttons{
    width:330px;
    margin:0 auto;
    &:after{
      content:'';
      clear:both;
      display:inline;
    }
  }
  &__buttonitem{
    float:left;
    width:160px;
    height:50px;
    &:not(:first-child){
      margin-left:10px;
    }
  }
}
.formfield{
  &__row{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: -5px;
  }
  &__inputitem{
    width: calc(20% - 10px);
    margin: 5px;
    height:50px;
    position: relative;
    text-align:left;
  }
}

</style>